'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (Jurisdiction) {
    Jurisdiction["MGA"] = "MGA";
    Jurisdiction["SGA"] = "SGA";
    Jurisdiction["UKGC"] = "UKGC";
    Jurisdiction["IAUI"] = "IAUI";
    Jurisdiction["LOTBA"] = "LOTBA";
    Jurisdiction["ONJN"] = "ONJN";
    Jurisdiction["AGCO"] = "AGCO";
    Jurisdiction["EMTA"] = "EMTA";
    Jurisdiction["SWEEPSTAKES"] = "SWEEPSTAKES";
    Jurisdiction["PAGCOR"] = "PAGCOR";
    Jurisdiction["DGOJ"] = "DGOJ";
})(exports.Jurisdiction || (exports.Jurisdiction = {}));
function isLOTBA(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.LOTBA;
}
function isONJN(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.ONJN;
}
function isAGCO(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.AGCO;
}
function isSGA(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.SGA;
}
function isUKGC(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.UKGC;
}
function isEMTA(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.EMTA;
}
function isPAGCOR(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.PAGCOR;
}
function isDGOJ(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.DGOJ;
}
function isSweepstakes(currentJurisdiction) {
    return currentJurisdiction === exports.Jurisdiction.SWEEPSTAKES;
}
var INITIAL_CASH_BALANCE_KEY = 'magic:initial_cash_balance';
var SESSION_START_TIME_KEY = 'magic:session_start_time';

exports.INITIAL_CASH_BALANCE_KEY = INITIAL_CASH_BALANCE_KEY;
exports.SESSION_START_TIME_KEY = SESSION_START_TIME_KEY;
exports.isAGCO = isAGCO;
exports.isDGOJ = isDGOJ;
exports.isEMTA = isEMTA;
exports.isLOTBA = isLOTBA;
exports.isONJN = isONJN;
exports.isPAGCOR = isPAGCOR;
exports.isSGA = isSGA;
exports.isSweepstakes = isSweepstakes;
exports.isUKGC = isUKGC;
